import { render } from "./AddPhone.vue?vue&type=template&id=b3e97e8a&scoped=true"
import script from "./AddPhone.vue?vue&type=script&lang=js"
export * from "./AddPhone.vue?vue&type=script&lang=js"

import "./AddPhone.vue?vue&type=style&index=0&id=b3e97e8a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e97e8a"]])

export default __exports__